import { render, staticRenderFns } from "./MessagingList.vue?vue&type=template&id=28ac8e4a"
import script from "./MessagingList.vue?vue&type=script&lang=js"
export * from "./MessagingList.vue?vue&type=script&lang=js"
import style0 from "./MessagingList.vue?vue&type=style&index=0&id=28ac8e4a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports